import React from 'react';
import '../../styles/shared.css';
import './RenewPage.css';

const RenewPage: React.FC = () => {
  return (
    <div className="page-container renew-page">
      <div className="page-header">
        <div className="header-content">
          <h1>续报中心</h1>
        </div>
      </div>
      
      <div className="content-container">
        <div className="renew-content">
          <div className="renew-card">
            <h3>可续报课程</h3>
            <div className="course-list">
              <div className="empty-state">
                <p>暂无可续报课程</p>
              </div>
            </div>
          </div>
          
          <div className="renew-notice">
            <h4>续报说明</h4>
            <ul>
              <li>老学员享受专属优惠价格</li>
              <li>提前续报可获得额外折扣</li>
              <li>续报成功后原课程自动延期</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewPage;